import {ReactElement} from 'react'
import {Trans} from 'react-i18next'
import {Grid, Typography} from '@material-ui/core'
import {Account} from '../../../../../graphql/types'
import messages from '../../../../../assets/messages'
import Amount from '../../../../Common/Amount'
import {StrategyInfo} from './components/StrategyInfo'
import {useStyles} from './styles'

type OverviewProps = {
  account: Account
}

export function Overview(props: OverviewProps): ReactElement {
  const {account} = props
  const {currency, balance, totalDeposits, totalWithdrawals, currentMonthDeposits, currentMonthWithdrawals} = account

  const classes = useStyles()

  const amountProps = {
    currency,
    locale: 'en-US',
    classes: {
      root: classes.amount,
      currency: classes.amountCurrency,
      value: classes.amountValue,
      fraction: classes.amountFraction
    }
  }

  return (
    <Grid container>
      <Grid item lg={4} xs={6} className={classes.item}>
        <Typography variant='caption'>
          <Trans {...messages.balance} />
        </Typography>
        <Amount value={balance ?? 0} {...amountProps} />
      </Grid>

      <Grid item lg={4} xs={6} className={classes.item}>
        <Typography variant='caption'>
          <Trans {...messages.monthlyEarnings} />
        </Typography>
        <Amount value={currentMonthDeposits ?? 0} {...amountProps} />
      </Grid>

      <Grid item lg={4} xs={6} className={classes.item}>
        <Typography variant='caption'>
          <Trans {...messages.monthlyWithdrawals} />
        </Typography>
        <Amount value={currentMonthWithdrawals ?? 0} {...amountProps} />
      </Grid>

      <Grid item lg={4} xs={6} className={classes.item}>
        <Typography variant='caption'>
          <Trans {...messages.totalEarnings} />
        </Typography>
        <Amount value={totalDeposits ?? 0} {...amountProps} />
      </Grid>

      <Grid item lg={4} xs={6} className={classes.item}>
        <Typography variant='caption'>
          <Trans {...messages.totalWithdrawals} />
        </Typography>
        <Amount value={totalWithdrawals ?? 0} {...amountProps} />
      </Grid>

      <StrategyInfo account={account} />
    </Grid>
  )
}
